import { d as defineProperties_1 } from '../define-properties/index.js';
import '../call-bind/index.js';
import { i as implementation$1 } from './implementation.js';
import { p as polyfill$1 } from './polyfill.js';
import { s as shim$1 } from './shim.js';
import { c as callBind$1 } from '../../_vendor/call-bind/index.js_commonjs-module.js';

var defineProperties = defineProperties_1;
var callBind = callBind$1.exports;

var implementation = implementation$1;
var getPolyfill = polyfill$1;
var shim = shim$1;

var polyfill = callBind.apply(getPolyfill());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
	return polyfill(Object, arguments);
};

defineProperties(bound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

var object_assign = bound;

export { object_assign as o };
